export const robotAudioKeys = {
  allRobots: ['audio'] as const,
  audio: (robotId: string) => [...robotAudioKeys.allRobots, robotId] as const,
};
